import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

const createActions = storeName => {
    const types = getTypes(storeName);
    const closeAndLogOut = createAction(types.CLOSE_AND_LOGOUT);
    const interruptLogin = createAction(types.INTERRUPT_LOGIN);
    const phoneNumberUpdated = createAction(types.PHONE_NUMBER_UPDATED);
    const guestUserAttemptedProfile = createAction(types.GUEST_USER_ATTEMPTED_PROFILE);
    const isCheckoutFlow = createAction(types.IS_CHECKOUT_FLOW);
    const toggleSuccessMsg = createAction(types.TOGGLE_SHOW_SUCCESS_MSG);
    const checkoutFlowEdit = createAction(types.EDIT_CHECKOUT_FLOW);
    const useAsPopup = createAction(types.USE_AS_POPUP);
    const updatePhonePopupEnabled = createAction(types.UPDATE_PHONE_POPUP_ENABLED);

    return {
        ...dynaForms.getActions(storeName),
        closeAndLogOut,
        interruptLogin,
        phoneNumberUpdated,
        guestUserAttemptedProfile,
        isCheckoutFlow,
        toggleSuccessMsg,
        checkoutFlowEdit,
        useAsPopup,
        updatePhonePopupEnabled,
    };
};

export default createActions;
